import styles from "../reseller.module.css"

export function HowToJoin() {
  const steps = [
    {
      number: "01",
      title: "Contact Admin",
      description: "Reach out to our admin team to express your interest in becoming a reseller.",
      icon: "📧",
    },
    {
      number: "02",
      title: "Submit Proof",
      description: "Provide credentials like gaming group screenshots or community verification.",
      icon: "✓",
    },
    {
      number: "03",
      title: "Get Validated",
      description: "Our admin team reviews and validates your application.",
      icon: "🔍",
    },
    {
      number: "04",
      title: "Start Earning",
      description: "Get promoted to Reseller account and begin your journey!",
      icon: "🚀",
    },
  ]

  return (
    <section className={styles.section}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>How to Join</h2>
        <p className={styles.sectionSubtitle}>Simple steps to become part of our cosmic community</p>
      </div>

      <div className={styles.stepsGrid}>
        {steps.map((step, index) => (
          <div key={index} className="relative group">
            {/* Card */}
            <div className={styles.stepCard}>
              {/* Step number */}
              <div className={styles.stepNumber}>{step.number}</div>

              {/* Icon */}
              <div className={styles.stepIcon}>{step.icon}</div>

              {/* Title */}
              <h3 className={styles.stepTitle}>{step.title}</h3>

              {/* Description */}
              <p className={styles.stepDescription}>{step.description}</p>

              {/* Connector line */}
              {index < steps.length - 1 && <div className={styles.stepConnector}></div>}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
